import {createSelector} from '@ngrx/store';
import {AppState} from 'src/app/store/app.state';

export const selectFeature = (state: AppState) => state.folders;

export const isFoldersLoadingSelector = createSelector(
	selectFeature,
	state => state.isLoading
);

export const accUuidSelector = createSelector(
	selectFeature,
	state => state.accUuid
);

export const selectedFoldersSelector = createSelector(
	selectFeature,
	state => state.selected
);

export const currentFolderSelector = createSelector(
	selectFeature,
	state => state?.currentFolder
);

export const foldersSelector = createSelector(
	selectFeature,
	state => state.folders
);

export const errorSelector = createSelector(
	selectFeature,
	state => state.error
);

export const folderDetailsSelector = createSelector(
	selectFeature,
	state => state.folderDetails
);

export const archivedFoldersSelector = createSelector(
	selectFeature,
	state => state.archivedFolders
);

export const trashedFoldersSelector = createSelector(
	selectFeature,
	state => state.trashedFolders
);

export const selectLatestCreatedFolderSelector = createSelector(
	selectFeature,
	state => state.latestCreatedFolder
);
